import { useQuery } from "@tanstack/react-query";
import { useAtomValue } from "jotai";
import { queriesEnabledAtom, tenantIDAtom } from "../../../atoms/GlobalAtoms";
import { BrieConversation } from "../../../components/BrieChatMenu/BrieMessages";
import BrieConversationAPI from "../../api/BrieConversationAPI";

interface UseGPTConversationsProps {
  conversations: Omit<BrieConversation, "Messages">[];
  conversationsLoading: boolean;
}

const defaultConvos: [] = [];

const useGPTConversations = (enabled: boolean | undefined = true) => {
  const queriesEnabled = useAtomValue(queriesEnabledAtom);
  const tenantID = useAtomValue(tenantIDAtom);

  const conversations = useQuery({
    queryKey: ["conversations-gpt", tenantID],
    queryFn: () =>
      BrieConversationAPI.getGPTConversations().then(
        (data) => data.data.data.conversations
      ),
    enabled: !!tenantID && queriesEnabled && enabled,
    staleTime: Infinity,
  });

  const result: UseGPTConversationsProps = {
    conversations: conversations.data || defaultConvos,
    conversationsLoading: conversations.isLoading || queriesEnabled === false,
  };

  return result;
};

export default useGPTConversations;
